<div class="course-details-breadcrumb-1 bg_image rts-section-gap">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <div class="single-course-left-align-wrapper">
          <div class="meta-area">
            <a class="text-white" [routerLink]="['/']">Início</a>
            <i class="fa-solid fa-chevron-right text-white"></i>
            <a class="active text-white" [routerLink]="['/facint-goiania']"
              >Faculdade Facint Goiânia</a
            >
          </div>
          <h1 class="title text-white">Conheça a Faculdade Facint Goiânia</h1>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="about-area-start style-two mb--200">
  <div class="container">
    <p class="paragraph">
      Conheça a unidade da Facint localizada na capital de Goiás, resultado da
      incorporação da tradicional Faculdade Falcão. Em breve, novos cursos e
      oportunidades.
    </p>

    <a
      href="https://faculdadefalcao.com.br"
      class="rts-btn btn-primary with-arrow"
      >Saiba mais <i class="fa-solid fa-arrow-right"></i
    ></a>
  </div>
</div>
